module.exports = __webpack_public_path__ + "img/traffic-light-stop.b0e7c209.svg";